// extracted by mini-css-extract-plugin
export default {"label":"CronForm_label__GC1EG","button":"CronForm_button__aQZWF"};